import { ɵɵdefineComponent, ɵɵelementStart, ɵɵelement, ɵɵelementEnd, ɵɵtext, ɵsetClassMetadata, Component, ɵɵadvance, ɵɵproperty, ɵɵsanitizeUrl, ɵɵtextInterpolate, Input, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵdirectiveInject, ɵɵtemplate, ɵɵtemplateRefExtractor, ɵɵreference, Inject, ɵɵinject, Injector, ɵɵdefineInjectable, Injectable } from '@angular/core';
import { __awaiter } from 'tslib';
import { trigger, transition, style, animate } from '@angular/animations';
import { NgIf, CommonModule } from '@angular/common';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector, PortalModule } from '@angular/cdk/portal';

class UserCardComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
UserCardComponent.ɵfac = function UserCardComponent_Factory(t) { return new (t || UserCardComponent)(); };
UserCardComponent.ɵcmp = ɵɵdefineComponent({ type: UserCardComponent, selectors: [["lib-user-card"]], decls: 4, vars: 0, consts: [[1, "image", "is-24x24"], ["src", "https://bulma.io/images/placeholders/24x24.png", 1, "is-rounded"]], template: function UserCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "figure", 0);
        ɵɵelement(1, "img", 1);
        ɵɵelementEnd();
        ɵɵelementStart(2, "span");
        ɵɵtext(3, " Martijn van den Berg\n");
        ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{display:flex;align-items:center}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{margin-left:12px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UserCardComponent, [{
        type: Component,
        args: [{
                selector: 'lib-user-card',
                templateUrl: './user-card.component.html',
                styleUrls: ['./user-card.component.scss']
            }]
    }], function () { return []; }, null); })();

class AuthUserDetailsComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
AuthUserDetailsComponent.ɵfac = function AuthUserDetailsComponent_Factory(t) { return new (t || AuthUserDetailsComponent)(); };
AuthUserDetailsComponent.ɵcmp = ɵɵdefineComponent({ type: AuthUserDetailsComponent, selectors: [["lib-auth-user-details"]], inputs: { profile: "profile" }, decls: 7, vars: 3, consts: [[1, "image", "is-32x32"], [1, "is-rounded", 3, "src"], [1, "details"], [1, "name"], [1, "function"]], template: function AuthUserDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "figure", 0);
        ɵɵelement(1, "img", 1);
        ɵɵelementEnd();
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 4);
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("src", ctx.profile == null ? null : ctx.profile.photoURL, ɵɵsanitizeUrl);
        ɵɵadvance(3);
        ɵɵtextInterpolate((ctx.profile == null ? null : ctx.profile.displayName) || "Aan het laden..");
        ɵɵadvance(2);
        ɵɵtextInterpolate((ctx.profile == null ? null : ctx.profile.displayName) ? "Systeembeheerder" : "-");
    } }, styles: ["[_nghost-%COMP%]{display:flex;align-items:center}.details[_ngcontent-%COMP%]{padding:4px 12px}.details[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{font-family:Roboto;font-style:normal;font-weight:500;font-size:14px;line-height:16px;letter-spacing:.216667px;color:#042c44}.details[_ngcontent-%COMP%]   .function[_ngcontent-%COMP%]{font-family:Roboto;font-style:normal;font-size:14px;line-height:16px;letter-spacing:.216667px;color:#8b919a;font-weight:400!important}figure[_ngcontent-%COMP%]{background:#dbdde0;border-radius:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthUserDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-auth-user-details',
                templateUrl: './auth-user-details.component.html',
                styleUrls: ['./auth-user-details.component.scss']
            }]
    }], function () { return []; }, { profile: [{
            type: Input
        }] }); })();

const DECLARED_EXPORTS = [UserCardComponent, AuthUserDetailsComponent];
class SharedLibraryModule {
}
SharedLibraryModule.ɵmod = ɵɵdefineNgModule({ type: SharedLibraryModule });
SharedLibraryModule.ɵinj = ɵɵdefineInjector({ factory: function SharedLibraryModule_Factory(t) { return new (t || SharedLibraryModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SharedLibraryModule, { declarations: [UserCardComponent, AuthUserDetailsComponent], exports: [UserCardComponent, AuthUserDetailsComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SharedLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: DECLARED_EXPORTS,
                imports: [],
                exports: DECLARED_EXPORTS
            }]
    }], null, null); })();

const notificationAnimation = {
    fadeNotification: trigger('fadeAnimation', [
        transition(':enter', [
            style({ opacity: 0, transform: 'translateY(30px)' }),
            animate('225ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
        ]),
        transition(':leave', [
            style({ opacity: 1, transform: 'translateY(0px)' }),
            animate('225ms ease-out', style({ opacity: 0, transform: 'translateY(30px)' })),
        ]),
    ]),
};

class NotificationData {
}

class NotificationRef {
    constructor(overlay) {
        this.overlay = overlay;
    }
    close() {
        this.overlay.dispose();
    }
}

function NotificationComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 6);
    ɵɵelementStart(1, "button", 7);
    ɵɵlistener("click", function NotificationComponent_div_6_Template_button_click_1_listener() { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.close(); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "button", 8);
    ɵɵlistener("click", function NotificationComponent_div_6_Template_button_click_3_listener() { ɵɵrestoreView(_r4); const ctx_r5 = ɵɵnextContext(); return ctx_r5.executeAction(); });
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.data.cancelText);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.data.okText);
} }
function NotificationComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 9);
    ɵɵlistener("click", function NotificationComponent_ng_template_7_Template_a_click_0_listener() { ɵɵrestoreView(_r7); const ctx_r6 = ɵɵnextContext(); return ctx_r6.close(); });
    ɵɵelementEnd();
} }
class NotificationComponent {
    constructor(data, ref) {
        this.data = data;
        this.ref = ref;
    }
    ngOnInit() {
        if (!this.data.action) {
            this.intervalId = setTimeout(() => this.close(), 5000);
        }
    }
    ngOnDestroy() {
        clearTimeout(this.intervalId);
    }
    executeAction() {
        return __awaiter(this, void 0, void 0, function* () {
            const action = this.data.caller ? this.data.action.bind(this.data.caller) : this.data.action;
            return yield action();
            this.close();
        });
    }
    close() {
        this.ref.close();
    }
}
NotificationComponent.ɵfac = function NotificationComponent_Factory(t) { return new (t || NotificationComponent)(ɵɵdirectiveInject(NotificationData), ɵɵdirectiveInject(NotificationRef)); };
NotificationComponent.ɵcmp = ɵɵdefineComponent({ type: NotificationComponent, selectors: [["lib-notification"]], decls: 9, vars: 5, consts: [[1, "wrapper"], [1, "notification-message"], [1, "headline"], [1, "subtext"], ["class", "buttons", 4, "ngIf", "ngIfElse"], ["noAction", ""], [1, "buttons"], [1, "cancel-button", 3, "click"], [1, "ok-button", 3, "click"], [1, "delete", 3, "click"]], template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "p", 2);
        ɵɵtext(3);
        ɵɵelementEnd();
        ɵɵelementStart(4, "p", 3);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵtemplate(6, NotificationComponent_div_6_Template, 5, 2, "div", 4);
        ɵɵelementEnd();
        ɵɵtemplate(7, NotificationComponent_ng_template_7_Template, 1, 0, "ng-template", null, 5, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(8);
        ɵɵproperty("@fadeAnimation", undefined);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.data.headline);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.data.subtext);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.data.action)("ngIfElse", _r1);
    } }, directives: [NgIf], styles: ["@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}.wrapper[_ngcontent-%COMP%]{margin:0;padding:24px;background-color:#fafafa;color:#005692;display:flex;width:100vw;box-shadow:0 0 4px rgba(0,0,0,.25)}.wrapper[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-top:24px}.wrapper[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:none;padding:12px;margin-left:12px;width:50%}.wrapper[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   button.ok-button[_ngcontent-%COMP%]{background-color:#005692;color:#fafafa}.wrapper[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   button.cancel-button[_ngcontent-%COMP%]{background-color:#fafafa;color:#005692;border:1px solid #005692}.wrapper[_ngcontent-%COMP%]   .notification-message[_ngcontent-%COMP%]{text-align:center;width:100%}@media (min-width:767px){.wrapper[_ngcontent-%COMP%]{margin:12px;width:auto}.wrapper[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]{justify-content:flex-end}.wrapper[_ngcontent-%COMP%]   .notification-message[_ngcontent-%COMP%]{text-align:left}}.icon[_ngcontent-%COMP%]{margin:6px}.delete[_ngcontent-%COMP%]{background-color:transparent;margin-left:6px}.notification-message[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-right:12px;min-width:20vw}.notification-message[_ngcontent-%COMP%]   .headline[_ngcontent-%COMP%]{font-family:Roboto;font-style:normal;font-weight:500;font-size:14px;line-height:16px;letter-spacing:.216667px}.notification-message[_ngcontent-%COMP%]   .subtext[_ngcontent-%COMP%]{font-family:Roboto;font-style:normal;font-weight:400;font-size:14px;line-height:16px;letter-spacing:.216667px}"], data: { animation: [notificationAnimation.fadeNotification] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-notification',
                templateUrl: './notification.component.html',
                styleUrls: ['./notification.component.scss'],
                animations: [notificationAnimation.fadeNotification],
            }]
    }], function () { return [{ type: NotificationData, decorators: [{
                type: Inject,
                args: [NotificationData]
            }] }, { type: NotificationRef }]; }, null); })();

class NotificationService {
    constructor(overlay, parentInjector) {
        this.overlay = overlay;
        this.parentInjector = parentInjector;
    }
    close() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }
    show(parentRef, data, position = {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
    }) {
        const positionStrategy = this.getPosition(parentRef, position);
        const overlayRef = this.overlay.create({ positionStrategy });
        const notificationRef = new NotificationRef(overlayRef);
        const injector = this.getInjector(data, notificationRef, this.parentInjector);
        const notificationPortal = new ComponentPortal(NotificationComponent, null, injector);
        overlayRef.attach(notificationPortal);
        return notificationRef;
    }
    getInjector(data, notificationRef, parentInjector) {
        const tokens = new WeakMap();
        tokens.set(NotificationData, data);
        tokens.set(NotificationRef, notificationRef);
        return new PortalInjector(parentInjector, tokens);
    }
    getPosition(parentRef, position) {
        return this.overlay
            .position()
            .flexibleConnectedTo(parentRef)
            .withPush(true)
            .withDefaultOffsetX(0)
            .withDefaultOffsetY(0)
            .withPositions([position]);
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵɵinject(Overlay), ɵɵinject(Injector)); };
NotificationService.ɵprov = ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: Overlay }, { type: Injector }]; }, null); })();

const DECLARED_EXPORTS$1 = [NotificationComponent];
class NotificationModule {
}
NotificationModule.ɵmod = ɵɵdefineNgModule({ type: NotificationModule });
NotificationModule.ɵinj = ɵɵdefineInjector({ factory: function NotificationModule_Factory(t) { return new (t || NotificationModule)(); }, providers: [NotificationService], imports: [[CommonModule, PortalModule, OverlayModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(NotificationModule, { declarations: [NotificationComponent], imports: [CommonModule, PortalModule, OverlayModule], exports: [NotificationComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotificationModule, [{
        type: NgModule,
        args: [{
                declarations: DECLARED_EXPORTS$1,
                imports: [CommonModule, PortalModule, OverlayModule],
                exports: DECLARED_EXPORTS$1,
                providers: [NotificationService],
            }]
    }], null, null); })();

/*
 * Public API Surface of shared-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthUserDetailsComponent, NotificationComponent, NotificationModule, NotificationService, SharedLibraryModule, UserCardComponent };
//# sourceMappingURL=shared-library.js.map
